import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import MultipleTextArea from "../../../../../ActiveLearning/MultipleTextArea";
import { IAnswer } from "../../../../../../constants/active_learning";
import styles from "../../../ActiveLearningIssue.module.scss";
import hintImage15 from "../../../../../../assets/images/ActiveLearning/hint/img_15.webp";

type Issue1MaterialProps = {
  issue?: IActiveLearningIssue;
};

export interface ICurrentAnswer extends IAnswer {
  good: string;
  motto: string;
}

export const Issue1Material = (props: Issue1MaterialProps) => {
  const question = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          行動した結果をまとめ、改善点があれば入力しよう。
        </p>
      </div>
      {question && (
        <div className={styles.themEntry}>
          <MultipleTextArea goodLabel={"わかったこと"} mottoLabel={"改善点"} />
        </div>
      )}
      <img src={hintImage15} alt="行動を振り返るためのヒント" />
    </div>
  );
};
export default Issue1Material;
